<template>
  <img
    :class="[$style.img, {[$style[size]]: size}]"
    :src="src"
    :height="height"
    :width="width || height"
    v-on="listeners"
  >
</template>

<script>
import { useRequireCompat } from '@/composables/require-compat/index.js'

export default {

  emits: [
    'click',
  ],
  props: {

    name: {
      type: String,
      default: '',
    },

    height: {
      type: String,
      default: '',
    },

    width: {
      type: String,
      default: null,
    },

    size: {
      type: String,
      default: '',
    },

    url: {
      type: String,
      required: false,
    },

    rotate: {
      type: String,
      required: false,
    },
  },

  computed: {
    listeners () {
      return {
        click: () => { this.$emit('click') },
      }
    },

    src () {
      if (!this.url) return ''

      return useRequireCompat({
        path: `@/assets/images/${this.url}`,
        glob: () => import.meta.glob('/src/assets/images/**/*', { eager: true, query: '?url', import: 'default' }),
      })
    },
  },
}
</script>

<style lang="scss" module>
.img {
  max-width: 100%;
  height: auto;
}
.icon {
  display: block;
  width: 1.5rem;
  height: 1.5rem;
}
.micro {
  width: .75rem;
  height: .75rem;
}
.small {
  width: 16px;
  height: 16px;
}
.medium {
  width: 32px;
  height: 32px;
}
.large {
  width: 40px;
  height: 40px;
}
.extralarge {
  width: 130px;
  height: 130px;
}

.rotate {
  &90 {
    transform: rotate(90deg)
  }
  &180 {
    transform: rotate(180deg)
  }
  &270 {
    transform: rotate(270deg)
  }
}
</style>
